import {Component, EventEmitter, HostListener, Input, Output,} from '@angular/core';
import {EsvgFiles} from 'frontier/nucleus';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';

@Component({
  selector: 'app-save-icon-button',
  templateUrl: './save-icon-button.component.html',
  styleUrls: ['./save-icon-button.component.css'],
  standalone: true,
  imports: [MatIconButton, MatIcon],
})
export class SaveIconButtonComponent {
  @Input() disabled: boolean;
  @Output() customClick = new EventEmitter();

  protected readonly EsvgFiles = EsvgFiles;

  @HostListener('window:keyup.Enter', ['$event'])
  onDialogClick(event: KeyboardEvent): void {
    // this.customClick.emit(event)
  }

  @HostListener('click', ['$event'])
  onClick(btn: MouseEvent) {
    if (this.disabled) {
      btn.preventDefault();
      btn.stopPropagation();
      btn.stopImmediatePropagation();
    } else {
      this.customClick.emit(btn);
    }
  }

  constructor() {
  }
}
